import { ref } from 'vue';

export class HtmlFormField {
	public content = ref<string>('');
	public numberOfCharacters = 0;

	public replaceContent(value: string): void {
		this.content.value = '';
		this.content.value = value;
	}

	public getNonWhitespaceContentOrNull(): string | null {
		if (this.content.value === undefined) {
			return null;
		}

		return this.content.value.trim().length > 0 ? this.content.value : null;
	}
}
